export const types = {
  UPDATE_PROJECT: 'UPDATE_PROJECT',
  ADD_PROJECT: 'ADD_PROJECT',
  REMOVE_PROJECT: 'REMOVE_PROJECT',
  FETCH_PROJECTS: 'FETCH_PROJECTS',
  SET_PROJECTS_LOADED: 'SET_PROJECTS_LOADED',
  REORDER_PROJECT: 'REORDER_PROJECT',
}
